(function () {
  'use strict'

  var MODULE_NAME = 'com.2fdevs.videogular.plugins.controls'
  var templateUrl = require('./tpl/tm-volume-bar.html')

  angular
    .module('com.2fdevs.videogular.plugins.controls')
    .run(
      ['$templateCache', function ($templateCache) {
        $templateCache.put('vg-templates/tm-volume-bar', templateUrl)
      }]
    )
    .directive('tmVolumeBar',
      ['VG_UTILS', function (VG_UTILS) {
        return {
          restrict: 'E',
          require: '^videogular',
          templateUrl: function (elem, attrs) {
            return attrs.vgTemplate || 'vg-templates/tm-volume-bar'
          },
          link: function (scope, elem, attr, API) {
            var isChangingVolume = false
            var volumeBackElem = angular.element(elem[0].getElementsByClassName('volumeBackground'))
            var volumeValueElem = angular.element(elem[0].getElementsByClassName('volumeValue'))
            var timeDisplay = []

            // TODO: Don't use DOM traversal to get time display elements.
            angular.forEach(elem.parent().parent().children(), function (child) {
              if (child.tagName === 'VG-TIME-DISPLAY') {
                timeDisplay.push(angular.element(child))
              }
            })

            scope.onClickVolume = function onClickVolume (event) {
              event = VG_UTILS.fixEventOffset(event)
              var volumeWidth = parseInt(volumeBackElem.prop('offsetWidth'))
              var value = event.offsetX * 100 / volumeWidth

              API.setVolume(value / 100)
            }

            scope.onMouseDownVolume = function onMouseDownVolume () {
              isChangingVolume = true
            }

            scope.onMouseUpVolume = function onMouseUpVolume () {
              isChangingVolume = false
            }

            scope.onMouseLeaveVolume = function onMouseLeaveVolume () {
              isChangingVolume = false
            }

            scope.onMouseMoveVolume = function onMouseMoveVolume (event) {
              if (isChangingVolume) {
                event = VG_UTILS.fixEventOffset(event)
                var volumeWidth = parseInt(volumeBackElem.prop('offsetWidth'))
                var value = event.offsetX * 100 / volumeWidth

                API.setVolume(value / 100)
              }
            }

            scope.updateVolumeView = function updateVolumeView (value) {
              value = value * 100
              volumeValueElem.css('width', value + '%')
            }

            scope.onChangeVisibility = function onChangeVisibility (value) {
              elem.css('visibility', value)
              angular.forEach(timeDisplay, function (element) {
                element.css('visibility', value === 'hidden' ? 'visible' : 'hidden')
              })
            }

            elem.css('visibility', scope.volumeVisibility)

            scope.$watch('volumeVisibility', scope.onChangeVisibility)

            // Update the volume bar on initialization, then watch for changes
            scope.updateVolumeView(API.volume)
            scope.$watch(
              function () {
                return API.volume
              },
              function (newVal, oldVal) {
                if (newVal !== oldVal) {
                  scope.updateVolumeView(newVal)
                }
              }
            )
          }
        }
      }]
    )

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/component/video/directive/tm-volume-bar.js